'use client';

import { DynamicHeroSlider } from './components/DynamicHeroSlider';
import { StandardHeroSlider } from './components/StandardHeroSlider';
import type { HeroSliderProps } from './HeroSlider.types';

export const HeroSlider = ({ dynamicBlogHero = false, ...props }: HeroSliderProps) => {
  if (dynamicBlogHero) {
    return <DynamicHeroSlider {...props} />;
  }

  return <StandardHeroSlider {...props} />;
};

HeroSlider.displayName = 'HeroSlider';
